module.exports = __webpack_public_path__ + "static/img/img_culture_a.45af319a.png";